import { Fragment, ReactElement } from 'react';
import { Button, Paper, Skeleton, Typography } from '@mui/material';

import { KnownDialogs, useDialog } from 'modules/dialogs';
import { useGlobalTranslation } from 'modules/i18n/hooks/useGlobalTranslation';

import { useStyles } from './useStyles';

export interface BaseIntroProps {
  title: string | ReactElement;
  stats: {
    label: string;
    value?: string;
  }[];
}

export function BaseIntro({ title, stats }: BaseIntroProps): ReactElement {
  const { classes } = useStyles();
  const { t, keys } = useGlobalTranslation();

  const { onOpen } = useDialog(KnownDialogs.connect);

  return (
    <Paper className={classes.root}>
      <Typography className={classes.title} variant="h1">
        {title}
      </Typography>

      <div className={classes.content}>
        <div className={classes.stats}>
          {stats.map(({ label, value }, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Fragment key={`${label}_${i}`}>
              {i !== 0 && <div className={classes.divider} />}

              <div className={classes.stat}>
                <Typography variant="h4">
                  {value || <Skeleton sx={{ minWidth: 100 }} />}
                </Typography>

                <Typography className={classes.label} variant="body1">
                  {label}
                </Typography>
              </div>
            </Fragment>
          ))}
        </div>

        <Button
          fullWidth
          className={classes.button}
          color="info"
          size="large"
          onClick={onOpen}
        >
          {t(keys.common.connectWallet)}
        </Button>
      </div>
    </Paper>
  );
}
